export const SupplierRoutes = {
  path: 'supplier',
  children: [
    {
      path: 'merge',
      async lazy() {
        const { Merge } = await import('pages/supplier');
        return { Component: Merge };
      },
    },
  ],
};
